import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../../colors-v2';
import { RendererWithPlugins } from '../../../../../../slatePlugins/components/core/readonly/RendererWithPlugins';
import { ParagraphPlugin } from '../../../../../../slatePlugins/components/core/readonly/ParagraphPlugin';
import { BoldReadOnlyPlugin } from '../../../../../../slatePlugins/marks/bold/BoldReadOnlyPlugin';
import { HeadingReadOnlyPlugin } from '../../../../../../slatePlugins/elements/heading/HeadingReadOnlyPlugin';
import { ItalicReadOnlyPlugin } from '../../../../../../slatePlugins/marks/italic/ItalicReadOnlyPlugin';
import { UnderlineColorReadOnlyPlugin } from '../../../../marks/underline-color/UnderlineColorPlugin';
interface Props {
  id?: string;
  onUpdateCaption?: (value: string) => void;
  onMouseDown?: (e) => void;
  caption?: any;
  placeholder?: string;
  isReadOnly?: boolean;
}

export const Wrapper = styled.div`
  &&& {
    .dol-editor {
      min-height: 20px;
      padding: 0 !important;
      font-family: Inter, sans-serif !important;

      .not-preview {
        color: ${colorsV2.black70};
      }
    }

    .custom-toolbar {
      background: ${colorsV2.white100};
      border: unset;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04),
        0 0 1px rgba(0, 0, 0, 0.04);
      border-radius: 8px;
    }
  }
`;

const plugins = [
  ParagraphPlugin,
  BoldReadOnlyPlugin(),
  HeadingReadOnlyPlugin(),
  // HighlightElementReadOnlyPlugin({
  //   colors: DEFAULT_HIGHLIGHT_COLORS_LIST,
  // }),
  ItalicReadOnlyPlugin(),
  UnderlineColorReadOnlyPlugin(),
  // StrikethroughReadOnlyPlugin(),
  // TextColorReadOnlyPlugin(),
  // QuoteReadOnlyPlugin(),
  // IconReadOnlyPlugin(),
  // RoundedElementReadOnlyPlugin(),
  // QuestionStyleReadOnlyPlugin(),
  // TextTransformPlugin(),
  // AbbrReadOnlyPlugin(),
  // CiteReadOnlyPlugin(),
  // QReadOnlyPlugin(),
];

export const InputCaptionTableComponentReadOnly = (props: Props) => {
  const { caption, onMouseDown } = props;
  return (
    <Wrapper contentEditable={false} className="input-caption-wrapper" onMouseDown={onMouseDown}>
      <RendererWithPlugins value={caption} plugins={plugins} />
    </Wrapper>
  );
};
